<template>
  <v-card class="contact-card mb-4" elevation="2">
    <v-card-title class="d-flex justify-space-between align-center">
      <span>{{ $t('contact_card.title') }} {{ index + 1 }}</span>
      <v-btn
        icon
        color="error"
        @click="$emit('remove')"
        class="remove-btn"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider class="mx-3" />

    <v-card-text>
      <v-row>
        <!-- Platform Selection -->
        <v-col cols="12" md="6">
          <v-select
            v-model="contactData.platform"
            :items="platformOptions"
            :label="$t('contact_card.platform')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.platform_required')]"
          />
        </v-col>

        <!-- Link -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contactData.link"
            :label="$t('contact_card.link')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.link_required')]"
          />
        </v-col>

        <!-- Line ID (only show when Line is selected) -->
        <v-col cols="12" md="6" v-if="contactData.platform === 'line'">
          <v-text-field
            v-model="contactData.lineId"
            :label="$t('contact_card.line_id')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.line_id_required')]"
          />
        </v-col>

        <!-- Image Link -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contactData.img"
            :label="$t('contact_card.image_link')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.image_required')]"
          />
        </v-col>

        <!-- Title Thai -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contactData.titleTh"
            :label="$t('contact_card.title_th')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.title_th_required')]"
          />
        </v-col>

        <!-- Title English -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contactData.titleEn"
            :label="$t('contact_card.title_en')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.title_en_required')]"
          />
        </v-col>

        <!-- Title Khmer -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contactData.titleKh"
            :label="$t('contact_card.title_kh')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.title_kh_required')]"
          />
        </v-col>

        <!-- Title Korean -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contactData.titleKr"
            :label="$t('contact_card.title_kr')"
            outlined
            dense
            required
            :rules="[v => !!v || $t('contact_card.title_kr_required')]"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ContactCard',
  props: {
    value: {
      type: Object,
      default: () => ({
        platform: '',
        link: '',
        titleTh: '',
        titleEn: '',
        titleKh: '',
        titleKr: '',
        lineId: '',
        img: ''
      })
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      platformOptions: [
        { text: 'Line', value: 'line' },
        { text: 'Facebook', value: 'facebook' },
        { text: 'Instagram', value: 'instagram' },
        { text: 'Telegram', value: 'telegram' },
        { text: 'Other', value: 'other' }
      ]
    }
  },
  computed: {
    contactData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    'contactData.platform'(newVal) {
      // Clear lineId when platform changes from line to something else
      if (newVal !== 'line') {
        this.contactData.lineId = ''
      }
    }
  }
}
</script>

<style scoped>
.contact-card {
  border-left: 4px solid #7367f0;
}

.remove-btn {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.remove-btn:hover {
  opacity: 1;
}
</style>
